import React, { useState } from "react";
import { Card, Grid, Icon, InputText, Link, Picture, Text } from "~/components-shared";
import { useTranslation } from "react-i18next";
import lists from "~/lib/lists";
import styled, { useTheme } from "styled-components";
const StyledGrid = styled(Grid)`
  max-height: 300px;
  overflow: auto;
`;
const TopicSummaryDocsCard = _ref => {
  let {
    documents,
    initialLimit = 3,
    ...rest
  } = _ref;
  const theme = useTheme();
  const {
    t
  } = useTranslation();
  const [limit, setLimit] = useState(initialLimit);
  const [query, setQuery] = useState("");
  let tempDocuments = documents;
  if (!tempDocuments.length) {
    return null;
  }
  const exceededLimit = tempDocuments.length > initialLimit;
  const exceededLimitBy = limit && tempDocuments.length > limit ? tempDocuments.length - limit : undefined;
  if (exceededLimitBy) {
    tempDocuments = tempDocuments.slice(0, limit);
  }
  const toggleLimit = () => {
    setLimit(prev => prev ? undefined : initialLimit);
    setQuery("");
  };
  const filteredDocs = tempDocuments.filter(_ref2 => {
    let {
      name
    } = _ref2;
    return query === "" || name?.toLowerCase().includes(query.toLowerCase());
  });
  return /*#__PURE__*/React.createElement(Card, rest, exceededLimit && !exceededLimitBy && /*#__PURE__*/React.createElement(InputText, {
    autoFocus: true,
    value: query,
    onChange: val => setQuery(val),
    elemBefore: /*#__PURE__*/React.createElement(Icon, {
      src: "search",
      s: {
        mr: 2
      }
    }),
    placeholder: t("common.actions.search"),
    fullWidth: true,
    clearButton: true,
    s: {
      mb: 4
    }
  }), filteredDocs.length ? /*#__PURE__*/React.createElement(StyledGrid, {
    cols: 3,
    gap: 4,
    template: "1.7rem 1fr"
  }, filteredDocs.map(document => /*#__PURE__*/React.createElement(React.Fragment, {
    key: document.id
  }, /*#__PURE__*/React.createElement(Picture, {
    border: "squared",
    src: lists.common.apps.logos(theme)[document.type],
    width: "1.7rem",
    height: "1.7rem",
    s: {
      mt: 2
    }
  }), /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Link, {
    href: document.url,
    color: theme.colors.text.primary,
    display: "block",
    fontSize: 4,
    weight: "semiBold"
  }, document.name), /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    weight: "semiBold"
  }, t("TopicSummaryCard.footprints", {
    count: document.footprintCount
  })))))) : /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    weight: "semiBold",
    fontSize: 4,
    s: {
      my: 2
    }
  }, "No documents"), exceededLimit && /*#__PURE__*/React.createElement(Link, {
    onClick: toggleLimit,
    s: {
      mt: 2
    },
    weight: "semiBold",
    color: theme.colors.text.secondary,
    underline: true
  }, exceededLimitBy ? `Show ${exceededLimitBy} more` : "Collapse list"));
};
export default TopicSummaryDocsCard;